module.exports = __webpack_public_path__ + "static/media/kid4.f2ad82f2.png";